'use strict';

var $ = require('jquery');
var reinitModules = require('../utilities/reinit-modules');

module.exports = function (options) {
    var context = options.context,
        body = $('body'),
        mobilebreakpoint = 768,
        windowwidth = $(window).width(),
        $submenu = context.find('[data-binding="submenu"]'),
        $slidepanel = context.find('[data-binding="slidepanel"]'),
        searching = false,
        footerTop = body.find('.site-footer').offset().top - 80;

    function slidePanel($el) {
        context.find('[data-binding="submenu"]').removeClass('active');
        $el.addClass('active');
        body.addClass('slidden');

        context.find('[data-binding="slidepanel"]').addClass('slide').attr('data-slidenumber', '2');
        context.find('[data-binding="slidepanel"]').css('height', context.find('[data-binding="submenu"].active').height());
    }

    function showResultsPanel() {
        context.find('[data-binding="submenu"]').removeClass('active');
        context.find('[data-binding="slidepanel"]').addClass('slideresults').attr('data-slidenumber', '3');
        body.addClass('slidden');
        removeFixedBottom();
        context.find('[data-binding="slidepanel"]').css('height', context.find('[data-binding="submenu"].active').height());
        context.find('[data-binding="resultslist"]').prepend('<button class="bird-identifier__fixed-top" data-binding="changleslide" data-slide="slide1">Add or amend options</button>');
    }

    function addBack() {
        context.find('[data-binding="submenu"]').prepend('<button class="bird-identifier__fixed-top" data-binding="changleslide" data-slide="slide1">Add or amend options</button>');
    }

    function addFixedBottom() {
        context.find('[data-binding="submenu"]').append('<div class="bird-identifier__fixed-bottom" data-binding="fixedbottom">' + '<button class="bird-identifier__fixed-bottom__possibilities" data-binding="possibilities">' + $('[data-binding="searchcount"]').text() + '</button>' + '</div>');
    }

    function removeFixedBottom() {
        context.find('[data-binding="fixedbottom"]').remove();
    }

    function countSelected() {
        var numberselected = context.find('.bird-identifier__options input:checked').length;

        return numberselected;
    }

    function getSelectedButton(item) {
        return '<button class="bird-identifier__fixed-bottom__current-indicator__item catitem" data-binding="currently-selected"' + 'data-name="' + item.category + '" ' + 'data-id="' + item.id + '">' + '<strong>' + item.category + ':</strong> ' + item.name + '</button>';
    }

    function getSelected() {
        var selected = [],
            multipleSelected;

        context.find('[data-binding="submenu"]').each(function () {
            var rowSelected = [],
                $currentsub = $(this);

            $currentsub.find('input:checked').each(function () {
                rowSelected.push({
                    'id': $(this).attr('id'),
                    'category': $(this).data('label'),
                    'name': $(this).next().text()

                });

                $currentsub.prev().addClass('hasitem');

                $currentsub.find('[data-binding="current-indicator"]').append('<button class="bird-identifier__fixed-bottom__current-indicator__item" data-binding="currently-selected" data-name="' + $(this).attr('name') + '" data-type="' + $(this).attr('type') + '" data-id="' + $(this).attr('id') + '">' + $(this).next().text() + '</button>').addClass('active');
            });
            for (var i = 0; i < rowSelected.length; i++) {
                $(this).closest('[data-binding="options"]').find('[data-binding="tagholder"]').append(getSelectedButton(rowSelected[i])).addClass('active');

                // if more than one items selected in a submenu set to true
                if (i > 0) {
                    multipleSelected = true;
                }
            }

            // then check var - if more than one items add a ... button at the end for mobile
            if (multipleSelected === true) {
                $(this).closest('[data-binding="options"]').find('[data-binding="tagholder"]').append('<button class="bird-identifier__fixed-bottom__current-indicator__item more">...</button>');

                $(this).closest('[data-binding="options"]').find('[data-binding="tagholder"] .bird-identifier__fixed-bottom__current-indicator__item:first-child').addClass('first');
            }

            //reset var ready for next menu item
            multipleSelected = false;

            selected.push.apply(selected, rowSelected);
        });

        if (selected.length > 0) {

            context.find('[data-binding="tagsummary"]').prepend('<button class="bird-identifier__fixed-bottom__current-indicator__item clear" data-binding="clear-selected">Clear all options</button>');

            context.find('[data-binding="tagsummary"]').prepend('<button class="bird-identifier__results__tagsummary__submit" data-binding="possibilities">' + $('[data-binding="searchcount"]').text() + '</button>');
        }
    }

    function changeSlide(el) {
        if (el.data('slide') === 'slide1') {
            context.find('[data-binding="slidepanel"]').removeClass('slide').attr('data-slidenumber', '1');
            context.find('[data-binding="slidepanel"]').removeClass('slideresults').attr('data-slidenumber', '1');
            context.find('[data-binding="current-indicator"]').removeClass('active');
            context.find('[data-binding="resultslist"] [data-binding="changleslide"]').remove();
            body.removeClass('slidden');
            context.find('[data-binding="questionbutton"]').removeClass('active');
            context.find('[data-binding="submenu"]').removeClass('active');
            context.find('[data-binding="question-overlay"]').remove();
            context.find('[data-binding="submenu"]').removeClass('active');
            removeFixedBottom();
        }
        if (el.data('slide') === 'slide2') {
            context.find('[data-binding="slidepanel"]').removeClass('slideresults').attr('data-slidenumber', '1');
            context.find('[data-binding="changleslide"]').attr('data-slide', 'slide1');
        }
    }

    function addLoading() {
        context.find('.bird-identifier__results').html('<div class="bird-identifier__loading"><img class="bird-identifier__loading__img" src="/Static/images/ajax-loading.gif" alt="Please wait whilst the web page loads"><p>Finding matching birds</p></div>');
    }

    function modalhtml($item) {
        context.find('[data-binding="modal-overlay"]').remove();

        $item.after('<div class="bird-identifier__modal__overlay" data-binding="modal-overlay">' + '<div class="bird-identifier__modal__container">' + '<button class="bird-identifier__modal__close" data-binding="modal-close">' + '<span class="bird-identifier__modal__close__desktop">X</span><span class="bird-identifier__modal__close__mobile">Back to search results</span></button>' + '<div class="bird-identifier__modal__content" data-binding="modal-content"></div>' + '<a href="/about-the-rspb/get-in-touch/contact-us#Wildlife-advice" class="bird-identifier__modal__footer">Didn\'t find what you were looking for?</a>' + '</div></div>');
    }

    function loadReload(slide, $active) {
        var openindex = 0;
        var bottomPos;

        addBack();

        if (slide === '2') {
            slidePanel($active);
            addFixedBottom();
        }

        getSelected();

        if (slide === '3') {
            showResultsPanel();
        }

        context.find('[data-binding="optioninput"]').on('change', function () {

            //enable search button in modal once an option has been changed
            context.find('[data-binding="perform-search"]').prop('disabled', false);

            context.find('[data-binding="untickoption"][data-id="' + $(this).attr('id') + '"]').remove();

            if ($(this).parent().hasClass('beakoption')) {
                if (context.find('[name="' + $(this).attr('name') + '"]').is(':checked')) {

                    $(this).closest('[data-binding="options-accordian"]').prev('[data-binding="selected-options-accordian"]').addClass('active');
                    $(this).closest('[data-binding="options-accordian"]').prev('[data-binding="selected-options-accordian"]').html('');
                    context.find('[name="' + $(this).attr('name') + '"]:checked').each(function () {
                        $(this).closest('[data-binding="options-accordian"]').prev('[data-binding="selected-options-accordian"]').append('<button class="bird-identifier__options__suboption__reveal__whatsticked__button" data-binding="untickoption" data-id="' + $(this).attr('id') + '">' + $(this).next().text() + '</button>');
                    });
                } else {
                    $(this).closest('[data-binding="options-accordian"]').prev('[data-binding="selected-options-accordian"]').removeClass('active');
                }
            }
        });

        context.on('click', '[data-binding="untickoption"]', function (e) {
            e.preventDefault();

            context.find('input#' + $(this).data('id')).prop('checked', false);

            if (!$(this).parent().next().find('[name="' + $(this).attr('name') + '"]').is(':checked')) {
                $(this).parent('[data-binding="selected-options-accordian"]').removeClass('active');
            }

            $(this).remove();
        });

        context.find('[data-binding="questionbutton"]').on('click', function (e) {
            e.preventDefault();

            if ($(this).hasClass('active')) {
                $(this).next().removeClass('active');
                $(this).removeClass('active');
                context.find('[data-binding="question-overlay"]').remove();
            } else {
                $submenu.removeClass('active');
                context.find('[data-binding="questionbutton"]').removeClass('active');
                slidePanel($(this).next($submenu));
                $(this).addClass('active');
                $(this).after('<div data-binding="question-overlay" class="bird-identifier__options__button__overlay"/>');
            }
        });

        context.on('click', '[data-binding="perform-search"]', function (e) {
            e.preventDefault();

            changeSlide($(this));
            context.find('[data-binding="question-overlay"]').remove();

            performSearch();
        });

        context.on('click', '[data-binding="cancel-search"]', function (e) {
            e.preventDefault();

            context.find('[data-binding="questionbutton"]').removeClass('active');
            context.find('[data-binding="submenu"]').removeClass('active');
            context.find('[data-binding="question-overlay"]').remove();
            changeSlide($(this));
        });

        context.on('click', '[data-binding="changleslide"]', function (e) {
            e.preventDefault();
            changeSlide($(this));
        });

        body.on('click', '[data-binding="modal-close"]', function (e) {
            e.preventDefault();
            $(this).closest('[data-binding="modal-overlay"]').remove();
            body.removeClass('pop');
            if (body.width() > 768) {
                body.removeClass('slidden');
            }
        });

        //reload results on paging change
        context.on('click', '.pagination__link', function (e) {
            e.preventDefault();
            context.find('[data-binding="page-number"]').val(parseInt($(this).attr('href').split('Page=')[1]));
            performSearch();
        });

        //open options accordian on beak selection
        context.find('[data-binding="options-accordian"]').addClass('inactive');
        context.find('[data-binding="open-options-accordian"]').addClass('inactive');
        context.on('click', '[data-binding="open-options-accordian"]', function (e) {
            e.preventDefault();

            if (openindex === $(this).index()) {
                //hide all accordians
                context.find('[data-binding="open-options-accordian"]').addClass('inactive');
                context.find('[data-binding="options-accordian"]').addClass('inactive');

                openindex = 0;
            } else {
                //hide all accordians
                context.find('[data-binding="open-options-accordian"]').addClass('inactive');
                context.find('[data-binding="options-accordian"]').addClass('inactive');

                // open selected accordian
                $(this).removeClass('inactive');
                $(this).next().next('[data-binding="options-accordian"]').removeClass('inactive');

                openindex = $(this).index();
            }
        });

        $(window).scroll(function () {
            bottomPos = $(window).scrollTop() + $(window).height();

            if (bottomPos >= footerTop) {
                context.find('[data-binding="possibilities"]').addClass('dontstick');
            } else {
                context.find('[data-binding="possibilities"]').removeClass('dontstick');
            }
        });
    }

    function performSearch() {
        var form = context.find('[data-binding="bird-id-form"]');
        var ajaxAction = form.data('action');
        var targetId = context;
        var slide = context.find('[data-binding="slidepanel"]').attr('data-slidenumber');
        var activeparentindex = parseInt(context.find('[data-binding="submenu"].active').parent().index());

        if (searching === false) {
            searching = true;
            addLoading();

            $.ajax({
                type: 'post',
                url: ajaxAction,
                data: form.serialize(),
                dataType: 'html',
                success: function success(data) {
                    $(targetId).html(data);
                    loadReload(slide, context.find('[data-binding="options"]:nth-child(' + (activeparentindex + 1) + ')').find('[data-binding="submenu"]'));
                    searching = false;
                    // call picturefill function to fix bug in IE11 not loading images after search
                    window.picturefill();
                },
                error: function error(request, status, _error) {
                    alert(_error);
                }
            });
        }
    }

    function init() {

        context.parent().addClass('loaded');

        loadReload('1');

        context.on('click', '[data-binding="possibilities"]', function (e) {
            e.preventDefault();
            showResultsPanel();
        });

        context.on('click', '[data-binding="currently-selected"]', function (e) {
            e.preventDefault();
            context.find('#' + $(this).attr('data-id')).prop('checked', false);
            $(this).remove();
            if (countSelected() === 0) {
                context.find('[data-binding="clear-selected"]').remove();
            }
            performSearch();
        });

        context.on('click', '[data-binding="clear-selected"]', function (e) {
            e.preventDefault();
            context.find('input[type="checkbox"], input[type="radio"]').prop('checked', false);
            performSearch();
        });

        context.on('click', '[data-binding="resultlink"]', function (e) {
            e.preventDefault();

            modalhtml($(this));

            body.addClass('slidden');
            body.addClass('pop');

            $(this).parent().find('[data-binding="modal-content"]').load($(this).data('href'), function () {
                reinitModules([{
                    name: 'species-gallery',
                    module: require('../modules/species-gallery')
                }, {
                    name: 'audio-player',
                    module: require('../modules/audio-player')
                }]);
                window.picturefill();
            });
        });

        context.on('click', '[data-binding="to-start"]', function (e) {
            e.preventDefault();
            $(this).closest('[data-binding="modal-overlay"]').remove();
            changeSlide($(this));
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/bird-identifier.js
// module id = 492
// module chunks = 0